import Vue from 'vue'
import router from './router/'
import store from './store/'
import './plugins/vuetify'
import './theme/default.sass'
import applyFilters from './filters'
import precision from './directives/precision'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueGtag from 'vue-gtag'
import wysiwyg from 'vue-wysiwyg'
import axios from 'axios'
import {Model} from 'vue-api-query'

Model.$http = axios

import '@mdi/font/css/materialdesignicons.css'
import 'vue-wysiwyg/dist/vueWysiwyg.css'

// Hack to gut out all service workers
if (typeof navigator !== undefined && navigator.serviceWorker !== undefined) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    for (let registration of registrations) {
      registration.unregister()
    }
  })
}

/**
 * Returns true if current uri is canonical (or not configured)
 * Returns false/redirects otherwise
 *
 * @returns {boolean}
 */
function isCanonicalUri() {
  // If canonical uri not configured, ignore
  if (!process.env.VUE_APP_BASE_URL) {
    return true
  }
  const currentPort =
    [`80`, `443`, ``].indexOf(window.location.port) > -1
      ? ``
      : `:${window.location.port}`
  const currentUri = `${window.location.protocol}//${window.location.hostname}${currentPort}`
  const canonicalUri = process.env.VUE_APP_BASE_URL
  if (currentUri !== canonicalUri && process.env.BYPASS_CANONICAL_CHECK !== 'true') {
    window.location.replace(canonicalUri + window.location.pathname + window.location.search + window.location.hash)
    return false
  }
  return true
}

Vue.config.productionTip = false

Vue.use(VueGtag, {
  bootstrap: false
}, router) // Pass router to enable pageview tracking

Vue.use(wysiwyg, {})

applyFilters(Vue)
Vue.directive('precision', precision)

// Mount the application; filters/components lazily fetch refinery settings as needed
function mountApp() {
  const app = new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  })
  Vue.prototype.__ = (key, ...params) => {
    return app.$vuetify.lang.translator(key, ...params)
  }
  app.$mount('#app')
}

// Use canonical URI check (will redirect if needed)
isCanonicalUri()

mountApp()